import React from 'react';
import { X } from 'lucide-react';

const getScoreColor = (score, maxScore) => {
    const percentage = (score / maxScore) * 100;
    if (percentage >= 80) return 'score-high';
    if (percentage >= 50) return 'score-medium';
    return 'score-low';
};

export function HistoryPanel({ history, showHistory, onClose, onLoadItem }) {
    if (!showHistory) return null;

    return (
        <div className="brutalist-card p-6 mb-8 fade-in" data-testid="history-panel">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Previous Submissions</h2>
                <button onClick={onClose} className="p-1 hover:bg-zinc-100 rounded">
                    <X className="w-5 h-5" />
                </button>
            </div>
            {history.length === 0 ? (
                <p className="text-zinc-500">No previous submissions yet.</p>
            ) : (
                <div className="space-y-3 max-h-64 overflow-y-auto">
                    {history.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => onLoadItem(item)}
                            className="w-full text-left p-4 border-2 border-zinc-200 rounded-lg hover:border-zinc-950 transition-colors"
                            data-testid={`history-item-${item.id}`}
                        >
                            <div className="flex items-center justify-between">
                                <span className="brutalist-badge text-xs">{item.subject}</span>
                                <span className={`brutalist-badge ${getScoreColor(item.score, item.max_score)}`}>
                                    {item.score}/{item.max_score}
                                </span>
                            </div>
                            <p className="mt-2 text-sm text-zinc-600 line-clamp-2">{item.question}</p>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
